//#region src/utils.ts
function handleAnyAttribute(element, name, value) {
	if (typeof name === "string" && name.startsWith("on") && typeof value === "function") {
		handleEventHandlerAttribute(element, name, value);
		return;
	}
	if (name in element || typeof name === "symbol") try {
		element[name] = value;
	} catch (_unused) {}
	else element.setAttribute(name, String(value));
}
function handleClassAttribute(element, value) {
	if (typeof value === "string") {
		element.classList = "";
		element.classList.add(...value.split(" ").filter(Boolean));
		return;
	}
	if (Array.isArray(value)) {
		value.filter(Boolean).forEach((className) => element.classList.add(className));
		return;
	}
	Object.entries(value).forEach(([className, shouldInclude]) => {
		element.classList.toggle(className, !!shouldInclude);
	});
}
function handleEventHandlerAttribute(element, name, value) {
	element.addEventListener(name.slice(2).toLowerCase(), value);
}
function handleStyleAttribute(element, value) {
	if (typeof value === "string") {
		element.setAttribute("style", value);
		return;
	}
	Object.assign(element.style, value);
}
function handleDataAttribute(element, value) {
	Object.assign(element.dataset, value);
}
function handleChildren(element, children) {
	childrenToNodes(children).forEach((node) => element.appendChild(node));
}
function childrenToNodes(children) {
	if (!Array.isArray(children)) children = [children];
	return children.map(childToNode).filter((node) => node !== null);
}
function childToNode(child) {
	if (child === null || child === void 0) return null;
	if (typeof child === "string" || typeof child === "number") return document.createTextNode(child.toString());
	else return child;
}

//#endregion
export { handleClassAttribute as a, handleChildren as i, childrenToNodes as n, handleDataAttribute as o, handleAnyAttribute as r, handleStyleAttribute as s, childToNode as t };
//# sourceMappingURL=utils-C8z7KYTJ.js.map